/**
 * The shape a structure module exports, plus small helpers for building one.
 *
 * A structure module bundles a `Structure` with the features and default
 * feature flags that extend it, so the three travel together as a single unit
 * wherever a structure is loaded. `features` is both the list config assembly
 * walks and, on a space or a story, the menu the toggle UI renders — so a
 * structure with nothing to group lists its features flat.
 */

import type { FeatureMenuItem } from 'feature/feature-helpers';
import type { Structure } from 'util/stdtypes';

export type StructureModule = {
    structure: Structure<any>;
    features: FeatureMenuItem[];
    defaultFeatures: Record<string, boolean>;
    logsFeatures?: boolean;
};

/** Wraps a bare `Structure` (no feature folder) into a `StructureModule`. */
export function wrapStructure(structure: any): StructureModule {
    return { structure, features: [], defaultFeatures: {} };
}
